import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-shared-table",
  templateUrl: "./shared-table.component.html",
  styleUrl: "./shared-table.component.scss",
})
export class SharedTableComponent implements OnInit {
  @Input() customTemplate?: TemplateRef<any>;
  @Output() onPageEvent = new EventEmitter<{ page: number; size: number }>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() archiveEvent = new EventEmitter<any>();
  @Input() searchResult!: any | null;
  currentPageIndex: number = 0;
  currentPageSize: number = 10;

  constructor(
    public _MatPaginatorIntl: MatPaginatorIntl,
    public translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.currentPageIndex = this.searchResult?.body?.page || 0;
    this.setPaginatorLabels();
  }

  setPaginatorLabels() {
    this.translate.get("PAGINATOR.FIRST_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.firstPageLabel = res;
    });
    this.translate.get("PAGINATOR.ITEMS_PER_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.itemsPerPageLabel = res;
    });
    this.translate.get("PAGINATOR.LAST_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.lastPageLabel = res;
    });
    this.translate.get("PAGINATOR.NEXT_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.nextPageLabel = res;
    });
    this.translate.get("PAGINATOR.PREVIOUS_PAGE").subscribe((res: string) => {
      this._MatPaginatorIntl.previousPageLabel = res;
    });
  }

  onPage(event: any): void {
    this.currentPageIndex = event.pageIndex;
    this.currentPageSize = event.pageSize;
    this.onPageEvent.emit({ page: event.pageIndex, size: event.pageSize });
  }

  trackByFn(index: number, item: any): any {
    return item.id;
  }
}
